import React from 'react';
import { ArrowUpRight, Calendar, CheckCircle2, ShieldCheck } from 'lucide-react';
import { services } from '../data/mock';

const NOTERRO_URL = 'https://auralune.noterro.com';

const Booking = () => {
  const openNoterro = () => {
    window.open(NOTERRO_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="booking" className="relative bg-[#EFE8DD] py-28 lg:py-36">
      <div className="vertical-divider hidden lg:block"></div>

      <div className="max-w-[1100px] mx-auto px-8 lg:px-12 relative">
        <div className="text-center mb-14">
          <p className="text-[11px] tracking-[0.3em] text-[#8B7FB8] font-medium mb-6">
            04 &nbsp;—&nbsp; BOOK
          </p>
          <h2 className="font-serif text-5xl lg:text-6xl leading-[1.05] text-[#1E1B18] mb-6">
            Book your session
          </h2>
          <p className="text-[15px] text-[#1E1B18]/70 leading-relaxed max-w-lg mx-auto">
            Real-time availability, instant confirmation, and secure patient records — all handled through my booking portal.
          </p>
        </div>

        <div className="bg-[#FBF7F0] border border-[#1E1B18]/10 rounded-sm p-10 lg:p-14 shadow-sm">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left column — services summary */}
            <div>
              <p className="text-[11px] tracking-[0.25em] text-[#8B7FB8] font-medium mb-5">
                SELECT A SERVICE ON THE NEXT STEP
              </p>
              <ul className="space-y-5">
                {services.map((s) => (
                  <li key={s.id} className="pb-5 border-b border-[#1E1B18]/10 last:border-b-0 last:pb-0">
                    <div className="flex items-start justify-between gap-4 mb-2">
                      <div className="text-[16px] font-medium text-[#1E1B18]">{s.name}</div>
                      <CheckCircle2 size={18} className="text-[#B9A9D6] mt-0.5 shrink-0" strokeWidth={1.6} />
                    </div>
                    <div className="grid grid-cols-4 gap-3 text-[12px]">
                      {s.prices.map((p) => (
                        <div key={p.duration} className="flex flex-col">
                          <span className="text-[#1E1B18]/50">{p.duration}</span>
                          <span className="text-[#1E1B18] font-medium">{p.price}</span>
                        </div>
                      ))}
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right column — CTA */}
            <div className="flex flex-col">
              <div className="space-y-3 mb-8">
                <div className="flex items-start gap-3">
                  <Calendar size={16} className="text-[#7B6BA6] mt-1 shrink-0" strokeWidth={1.6} />
                  <div>
                    <div className="text-[14px] font-medium text-[#1E1B18]">See live availability</div>
                    <div className="text-[12px] text-[#1E1B18]/60">Only the times I'm actually open are shown.</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle2 size={16} className="text-[#7B6BA6] mt-1 shrink-0" strokeWidth={1.6} />
                  <div>
                    <div className="text-[14px] font-medium text-[#1E1B18]">Instant confirmation</div>
                    <div className="text-[12px] text-[#1E1B18]/60">You'll get an email as soon as it's booked.</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <ShieldCheck size={16} className="text-[#7B6BA6] mt-1 shrink-0" strokeWidth={1.6} />
                  <div>
                    <div className="text-[14px] font-medium text-[#1E1B18]">PHIPA-compliant records</div>
                    <div className="text-[12px] text-[#1E1B18]/60">Your intake and session notes stay private and secure.</div>
                  </div>
                </div>
              </div>

              <button
                onClick={openNoterro}
                className="w-full inline-flex items-center justify-center gap-2 bg-[#0F0E0C] hover:bg-[#2A2622] text-[#F4EFE7] py-4 rounded-full text-[14px] font-medium transition-all hover:scale-[1.01] shadow-sm"
              >
                Book on Noterro
                <ArrowUpRight size={16} />
              </button>
              <p className="text-[11px] text-[#1E1B18]/50 text-center mt-4 leading-relaxed">
                Opens my secure booking portal in a new tab.
                <br />Insurance receipts available after your session.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Booking;
